import twitter from '../../assets/images/twitter.png';
import facebook from '../../assets/images/facebook.png';
import linkedin from '../../assets/images/linkedin.png';
import medium from '../../assets/images/medium.jpg';
import github from '../../assets/images/github.png';

const defaultNetworksIconsData = [
  // {
  //   title: 'rss',
  //   link: 'https://dormoshe.io/rss.xml',
  //   imgSrc: rss
  // },  
  {
    title: 'twitter',
    link: 'https://twitter.com/DorMoshe',
    imgSrc: twitter
  },
  {
    title: 'linkedin',
    link: 'https://www.linkedin.com/in/dormoshe',
    imgSrc: linkedin
  },
  {
    title: 'facebook',
    link: 'https://www.facebook.com/groups/angular2typescript',
    imgSrc: facebook
  },
  {
    title: 'medium',
    link: 'https://medium.com/@dormoshe',
    imgSrc: medium
  }, 
  {
    title: 'github',
    link: 'https://github.com/dormd',
    imgSrc: github
  }
];

function getIconsData(iconsDataInfo) {
  if (!iconsDataInfo) return defaultNetworksIconsData;

  const result = [];
    // {
    //   title: 'rss',
    //   link: 'https://dormoshe.io/rss.xml',
    //   imgSrc: rss
    // },  
  if (iconsDataInfo.twitterUserId) {
    result.push({
      title: 'twitter',
      link: `https://twitter.com/${iconsDataInfo.twitterUserId}`,
      imgSrc: twitter
    });
  }

  if (iconsDataInfo.linkedinUserId) {
    result.push({
      title: 'linkedin',
      link: `https://www.linkedin.com/in/${iconsDataInfo.linkedinUserId}`,
      imgSrc: linkedin
    });
  }

  if (iconsDataInfo.facebookGroupId) {
    result.push({
      title: 'facebook',
      link: `https://www.facebook.com/groups/${iconsDataInfo.facebookGroupId}`,
      imgSrc: facebook
    });
  }  

  if (iconsDataInfo.facebookUserId) {
    result.push({
      title: 'facebook',
      link: `https://www.facebook.com/${iconsDataInfo.facebookUserId}`,
      imgSrc: facebook
    });
  }    

  if (iconsDataInfo.mediumUserId) {
    result.push({
      title: 'medium',
      link: `https://medium.com/@${iconsDataInfo.mediumUserId}`,
      imgSrc: medium
    });
  }  

  if (iconsDataInfo.githubUserId) {
    result.push({
      title: 'github',
      link: `https://github.com/${iconsDataInfo.githubUserId}`,
      imgSrc: github
    });
  }  

  return result;
}

export default {
  getIconsData
};